import BulkLoadLocations from '../navPages/BulkLoadLocations'
import MyLibraryDocumentsCN from '../contentPages/MyLibraryDocumentsCN'
import ImagesLibraryCN from '../navPages/ImagesLibraryCN'
import LocationsLibrary from '../navPages/LocationsLibrary'
import PortfoliosLibrary from '../navPages/PortfoliosLibrary'
import ProjectsLibrary from '../navPages/ProjectsLibrary'
import SiteDetails from '../navPages/SiteDetails'
import Tasks from '../navPages/Tasks'
import UserProfile from '../navPages/UserProfile'
import routes from 'constants/routes'

const getAdminRoutes = (
	param: 'locations' | 'projects' | 'portfolios' | 'library' | 'templates' | 'userprofile' | 'archives' | 'utilities',
) => {
	if (param === 'library') {
		return [
			{
				linkText: 'Documents ',
				linkTo: `${routes.ADMIN}/${param}/documents`,
				linkPattern: `${routes.ADMIN}/${param}/documents`,
				component: MyLibraryDocumentsCN,
			},
			{
				linkText: 'Images ',
				linkTo: `${routes.ADMIN}/${param}/images`,
				linkPattern: `${routes.ADMIN}/${param}/images`,
				component: ImagesLibraryCN,
			},

			{
				redirectFrom: `${routes.ADMIN}/${param}`,
				redirectTo: `${routes.ADMIN}/${param}/documents`,
			},
		]
	}

	if (param === 'locations') {
		return [
			{
				linkText: 'Location Library ',
				linkTo: `${routes.ADMIN}/${param}/library`,
				linkPattern: `${routes.ADMIN}/${param}/library`,
				component: LocationsLibrary,
			},
			{
				linkText: 'Load Bulk Locations ',
				linkTo: `${routes.ADMIN}/${param}/loader`,
				linkPattern: `${routes.ADMIN}/${param}/loader`,
				component: BulkLoadLocations,
			},

			{
				redirectFrom: `${routes.ADMIN}/${param}`,
				redirectTo: `${routes.ADMIN}/${param}/library`,
			},
		]
	}

	if (param === 'portfolios') {
		return [
			{
				linkText: 'Portfolios ',
				linkTo: `${routes.ADMIN}/${param}/`,
				linkPattern: `${routes.ADMIN}/${param}/`,
				component: PortfoliosLibrary,
			},
			{
				redirectFrom: `${routes.ADMIN}/${param}`,
				redirectTo: `${routes.ADMIN}/${param}/`,
			},
		]
	}

	if (param === 'projects') {
		return [
			{
				linkText: 'Projects ',
				linkTo: `${routes.ADMIN}/${param}/`,
				linkPattern: `${routes.ADMIN}/${param}/`,
				component: ProjectsLibrary,
			},
			{
				redirectFrom: `${routes.ADMIN}/${param}`,
				redirectTo: `${routes.ADMIN}/${param}/`,
			},
		]
	}

	if (param === 'templates') {
		return [
			{
				linkText: 'Task Templates',
				linkTo: `${routes.ADMIN}/${param}/tasks`,
				linkPattern: `${routes.ADMIN}/:param/tasks`,
				component: Tasks,
			},
			{
				linkText: 'Site Detail Templates ',
				linkTo: `${routes.ADMIN}/${param}/sitedetails`,
				linkPattern: `${routes.ADMIN}/:param/sitedetails`,
				component: SiteDetails,
			},
			{
				redirectFrom: `${routes.ADMIN}/${param}`,
				redirectTo: `${routes.ADMIN}/${param}/tasks`,
			},
		]
	}

	if (param === 'archives') {
		return [
			{
				linkText: 'Locations',
				linkTo: `${routes.ADMIN}/archives/locations`,
				linkPattern: `${routes.ADMIN}/archives/locations`,
				component: LocationsLibrary,
			},
			// Evaluation Sites moved to MAIN/Evaluations (routes.ALL_SITES) and
			// is no longer listed as an Archives tab. The legacy URL is still
			// routed in AppRoutes so old links resolve.
			{
				redirectFrom: `${routes.ADMIN}/archives`,
				redirectTo: `${routes.ADMIN}/archives/locations`,
			},
		]
	}

	if (param === 'utilities') {
		return [
			{
				linkText: 'Bulk Load',
				linkTo: `${routes.ADMIN}/utilities/bulkload`,
				linkPattern: `${routes.ADMIN}/utilities/bulkload`,
				component: BulkLoadLocations,
			},
			{
				linkText: 'Task Templates',
				linkTo: `${routes.ADMIN}/utilities/tasks`,
				linkPattern: `${routes.ADMIN}/utilities/tasks`,
				component: Tasks,
			},
			{
				linkText: 'Site Detail Templates',
				linkTo: `${routes.ADMIN}/utilities/sitedetails`,
				linkPattern: `${routes.ADMIN}/utilities/sitedetails`,
				component: SiteDetails,
			},
			{
				redirectFrom: `${routes.ADMIN}/utilities`,
				redirectTo: `${routes.ADMIN}/utilities/bulkload`,
			},
		]
	}

	if (param === 'userprofile') {
		return [
			{
				linkText: 'User Profile ',
				linkTo: `${routes.ADMIN}/${param}/`,
				linkPattern: `${routes.ADMIN}/${param}/`,
				component: UserProfile,
			},
			{
				redirectFrom: `${routes.ADMIN}/${param}`,
				redirectTo: `${routes.ADMIN}/${param}/`,
			},
		]
	}
}
export default getAdminRoutes
